import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';
import { useAuthContext } from '@/context/AuthContext';
import {useAppSelector} from '@/store/hooks.js';

// Requête pour obtenir toutes les TVA
const GET_ALL_VATS = gql`
  query ALL_VATS($companyUuid: ID!) {
    allVat(companyUuid: $companyUuid) {
      rate
      status
      uuid
    }
  }
`;

// Hook personnalisé
export const useAllVats = () => {
  const user = useAppSelector((state) => state.auth.currentUser);
  const companyUuid = user.company.uuid;

  const { loading, error, data, refetch } = useQuery(GET_ALL_VATS, {
    variables: { companyUuid },

    fetchPolicy: "network-only", // S'assure que les données sont toujours récupérées du serveur
  });

  return {
    loading,
    error,
    data: data?.allVat,
    refetch
  };
};

// Hook personnalisé pour obtenir toutes les TVA actives
export const useActiveVats = () => {
  const user = useAppSelector((state) => state.auth.currentUser);
  const companyUuid = user.company.uuid;

  const { loading, error, data, refetch } = useQuery(GET_ALL_VATS, {
    variables: { companyUuid },

    fetchPolicy: "network-only",
  });

  const activeVats = data?.allVat
    .filter(vat => vat.status === "ACTIVE")
    .sort((a, b) => a.rate - b.rate);

  return {
    loading,
    error,
    data: activeVats,
    refetch
  };
};
